import ReactMounter from 'lib/ReactMounter'
import ServicesPage from 'pages/ServicesPage/ServicesPage'

ReactMounter.registerComponentToMountOnLoad('ServicesPage', ServicesPage)
